import BlockSettings from '@/components/blocks/BlockSettings';
import BlockEditAgent from '@/components/blocks/Admin/Agents/BlockEditAgent';
import SuperOrAgent from '@/services/RouteGuards/SuperOrAgent';

export default [
	{
		path: 'settings',
		name: 'SettingsAgent',
		component: BlockSettings,
		meta: {
			title: `Settings - ${process.env.VUE_APP_NAME}`
		},
		beforeEnter: SuperOrAgent
	},
	{
		path: 'my-account/edit/:id',
		name: 'MyAccountAgent',
		component: BlockEditAgent,
		props: {
			edit: true,
			myAccount: true,
			data: {
				type: Object,
				required: true
			}
		},
		meta: {
			title: `My Account - ${process.env.VUE_APP_NAME}`
		}
	}
];
